import LocationEditor from './LocationEditor';

export default LocationEditor;
